const categoryItems = [
  {
    name: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    bgClass: "bg-accent-100/60",
    imageUrl: "https://readdy.ai/api/search-image?query=Minimalist%20fashion%20sneakers%20on%20clean%20cream%20background%2C%20soft%20studio%20lighting%2C%20editorial%20product%20photography%2C%20warm%20neutral%20tones%2C%20european%20aesthetic%2C%20high%20detail%2C%20simple%20elegant%20composition&width=600&height=750&seq=cat-img-shoes&orientation=portrait",
  },
  {
    name: "Hoodies & Sweaters",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    bgClass: "bg-secondary-100/60",
    imageUrl: "https://readdy.ai/api/search-image?query=Oversized%20hoodie%20and%20sweater%20flatlay%20on%20neutral%20beige%20surface%2C%20soft%20natural%20light%2C%20minimalist%20product%20photography%2C%20warm%20earthy%20tones%2C%20clean%20editorial%20style%2C%20textile%20texture%20visible&width=600&height=750&seq=cat-img-hoodies&orientation=portrait",
  },
  {
    name: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    bgClass: "bg-primary-100/60",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20cotton%20t-shirt%20folded%20neatly%20on%20light%20cream%20backdrop%2C%20minimalist%20studio%20lighting%2C%20clean%20product%20photography%2C%20soft%20shadows%2C%20warm%20neutral%20aesthetic%2C%20editorial%20style&width=600&height=750&seq=cat-img-tshirts&orientation=portrait",
  },
  {
    name: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    bgClass: "bg-accent-200/50",
    imageUrl: "https://readdy.ai/api/search-image?query=Designer%20jacket%20on%20minimalist%20wooden%20hanger%2C%20warm%20neutral%20background%2C%20soft%20studio%20light%2C%20elegant%20product%20photography%2C%20organic%20texture%2C%20european%20fashion%20editorial%20feel&width=600&height=750&seq=cat-img-jackets&orientation=portrait",
  },
  {
    name: "Pants & Shorts",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    bgClass: "bg-secondary-200/50",
    imageUrl: "https://readdy.ai/api/search-image?query=Tailored%20pants%20and%20shorts%20flatlay%20on%20clean%20beige%20surface%2C%20minimalist%20aesthetic%2C%20soft%20lighting%2C%20warm%20tones%2C%20editorial%20product%20photography%2C%20fabric%20texture%20details&width=600&height=750&seq=cat-img-pants&orientation=portrait",
  },
  {
    name: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    bgClass: "bg-primary-200/50",
    imageUrl: "https://readdy.ai/api/search-image?query=Stylish%20caps%20and%20beanies%20arranged%20on%20minimalist%20cream%20surface%2C%20clean%20studio%20lighting%2C%20warm%20neutral%20tones%2C%20editorial%20photography%2C%20european%20streetwear%20aesthetic&width=600&height=750&seq=cat-img-headwear&orientation=portrait",
  },
  {
    name: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    bgClass: "bg-accent-100/60",
    imageUrl: "https://readdy.ai/api/search-image?query=Coordinated%20matching%20clothing%20set%20displayed%20on%20neutral%20background%2C%20minimalist%20photography%2C%20soft%20light%2C%20warm%20earthy%20tones%2C%20clean%20editorial%20composition&width=600&height=750&seq=cat-img-sets&orientation=portrait",
  },
  {
    name: "Underwear & Underpants",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    bgClass: "bg-secondary-100/60",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20underwear%20basics%20neatly%20folded%20on%20cream%20backdrop%2C%20minimalist%20product%20photography%2C%20soft%20studio%20light%2C%20warm%20tones%2C%20clean%20elegant%20aesthetic&width=600&height=750&seq=cat-img-underwear&orientation=portrait",
  },
  {
    name: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    bgClass: "bg-primary-100/60",
    imageUrl: "https://readdy.ai/api/search-image?query=Sports%20jersey%20displayed%20on%20minimalist%20neutral%20surface%2C%20soft%20studio%20lighting%2C%20warm%20tones%2C%20editorial%20product%20photography%2C%20athletic%20aesthetic%2C%20clean%20composition&width=600&height=750&seq=cat-img-jersey&orientation=portrait",
  },
  {
    name: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    bgClass: "bg-accent-200/50",
    imageUrl: "https://readdy.ai/api/search-image?query=Fashion%20accessories%20including%20watch%20and%20bracelet%20on%20cream%20surface%2C%20minimalist%20photography%2C%20soft%20light%2C%20warm%20neutral%20tones%2C%20editorial%20style%2C%20elegant%20composition&width=600&height=750&seq=cat-img-accessories&orientation=portrait",
  },
  {
    name: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    bgClass: "bg-secondary-200/50",
    imageUrl: "https://readdy.ai/api/search-image?query=Designer%20handbag%20and%20backpack%20on%20clean%20beige%20background%2C%20minimalist%20product%20photography%2C%20soft%20studio%20light%2C%20warm%20neutrals%2C%20european%20fashion%20aesthetic&width=600&height=750&seq=cat-img-bags&orientation=portrait",
  },
  {
    name: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    bgClass: "bg-primary-200/50",
    imageUrl: "https://readdy.ai/api/search-image?query=Premium%20leather%20belts%20displayed%20on%20cream%20surface%2C%20minimalist%20studio%20photography%2C%20soft%20lighting%2C%20warm%20tones%2C%20editorial%20accessory%20photography%2C%20clean%20composition&width=600&height=750&seq=cat-img-belts&orientation=portrait",
  },
  {
    name: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    bgClass: "bg-accent-100/60",
    imageUrl: "https://readdy.ai/api/search-image?query=Elegant%20perfume%20bottles%20arranged%20on%20minimalist%20beige%20surface%2C%20soft%20natural%20light%2C%20warm%20tones%2C%20editorial%20beauty%20photography%2C%20clean%20sophisticated%20aesthetic&width=600&height=750&seq=cat-img-perfumes&orientation=portrait",
  },
  {
    name: "Other Stuff",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    bgClass: "bg-secondary-100/60",
    imageUrl: "https://readdy.ai/api/search-image?query=Assorted%20lifestyle%20products%20flatlay%20on%20neutral%20cream%20background%2C%20minimalist%20photography%2C%20soft%20lighting%2C%20warm%20tones%2C%20editorial%20style%2C%20organized%20composition&width=600&height=750&seq=cat-img-other&orientation=portrait",
  },
];

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8 md:mb-12">
          <p className="text-xs md:text-sm uppercase tracking-[0.15em] text-foreground-500 font-label mb-2">
            Shop The Look
          </p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
            Explore
            <br />
            <span className="italic font-normal text-foreground-700">Every Category</span>
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {categoryItems.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className={`group block rounded-2xl overflow-hidden ${cat.bgClass} transition-all duration-300 hover:scale-[1.02] cursor-pointer`}
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading={index < 4 ? "eager" : "lazy"}
                />
              </div>
              <div className="px-4 py-3 bg-white/80 backdrop-blur-sm">
                <span className="text-sm md:text-base font-label font-semibold text-foreground-950 whitespace-nowrap">
                  {cat.name}
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}